var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGainMuscle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 42,
    height: 42,
    transform: "translate(584 489)",
    fill: "#ebc5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305eba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-584 -489)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "muscles",
    transform: "translate(584 489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M36.181,15.753l-.306,0A11.336,11.336,0,0,0,25.82,21.868a9.5,9.5,0,0,0-10.093,1.37,36.233,36.233,0,0,0-.42-4.33,25.85,25.85,0,0,1-.331-3.159H19.4a2.609,2.609,0,0,0,1.856-.769l3.5-3.5a2.617,2.617,0,0,0,.052-3.633,2.615,2.615,0,0,0-.725-3.635L21.96,2.8A6.21,6.21,0,0,0,18.5,1.75a9.571,9.571,0,0,0-6.813,2.822A37.321,37.321,0,0,0,3.848,15.982C1.617,21.064.485,24.813.485,27.125a12.164,12.164,0,0,1-.341,3.2A3.882,3.882,0,0,0,2,34.745a41.848,41.848,0,0,0,20.727,5.5h1.265A41.705,41.705,0,0,0,37.2,38.106l.613-.205A6.115,6.115,0,0,0,42,32.091V21.883A6.1,6.1,0,0,0,36.181,15.753ZM40.25,32.091a4.369,4.369,0,0,1-2.992,4.15l-.613.205A39.97,39.97,0,0,1,23.988,38.5H22.722A40.09,40.09,0,0,1,2.863,33.226,2.137,2.137,0,0,1,1.828,30.8a13.822,13.822,0,0,0,.408-3.676c0-2.039,1.112-5.648,3.216-10.439A35.555,35.555,0,0,1,12.928,5.81,7.833,7.833,0,0,1,18.5,3.5a4.467,4.467,0,0,1,2.486.753l2.124,1.416a.876.876,0,0,1,.134,1.347L20.453,9.811a.981.981,0,0,1-1.388-1.388l.8-.8a.875.875,0,1,0-1.237-1.237l-.8.8a2.731,2.731,0,1,0,3.862,3.862L23.6,9.134a.865.865,0,0,1-.084,1.11l-3.5,3.5A.881.881,0,0,1,19.4,14H15.315a1.32,1.32,0,0,1,.179-.256.875.875,0,0,0-1.237-1.237c-1.431,1.431-1.083,3.85-.681,6.651A31.587,31.587,0,0,1,14,23.625c0,3.6-2.727,4.372-2.844,4.4a.875.875,0,0,0,.431,1.7,5.7,5.7,0,0,0,3.628-3.33c.012-.016.031-.022.042-.039a7.876,7.876,0,0,1,12.161-1.324.875.875,0,1,0,1.232-1.242,9.689,9.689,0,0,0-1.307-1.066A9.6,9.6,0,0,1,35.875,17.5l.259,0a4.337,4.337,0,0,1,4.116,4.379V32.091Z",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainMuscle);
export default __webpack_public_path__ + "static/media/gain-muscle.cc673e6f85ad695e59acb587723636c2.svg";
export { ForwardRef as ReactComponent };